"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { MapPin } from "lucide-react";
export default function DeliveryRegions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const regions = ["Красно село", "Овча купел", "Бъкстон", "Борово", "Манастирски ливади", "Павлово", "Княжево", "Горна баня", "Бистрица", "Симеоново", "Бояна", "Хладилника", "Кръстова вада", "Южен парк"];
  return <section id="deliveryregions" ref={ref} className="py-16 md:py-24 bg-cover bg-center bg-no-repeat !bg-[url(https://mishmashinterpred.com/wp-content/uploads/2026/02/delivery_service_background.webp)] bg-primary/10">
      <div className="container">
      <div className={`transition-all duration-700 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Card className="card max-w-4xl mx-auto px-6">
          <CardHeader className="text-center">
            <div className="flex items-center justify-center gap-3 mb-2">
              <MapPin className="size-8 text-primary" />
              <CardTitle className="text-3xl md:text-4xl">
                Зони на доставка
              </CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {regions.map((region, i) => <div key={i} data-index={i} className="flex items-center gap-1.5 p-2 rounded-lg bg-white hover:bg-primary/5 transition-colors duration-200">
                  <div className="size-1.5 rounded-full bg-primary shrink-0" />
                  <span className="text-xs font-medium leading-tight break-words">{region}</span>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
      </div>
    </section>;
}